import { API_BASE_URL } from "@/config/api";
import { supabase } from "@/index";

interface ApiOptions {
  method?: "GET" | "POST" | "DELETE" | "PATCH";
  body?: any;
  headers?: Record<string, string>;
}

export async function apiRequest<T>(
  endpoint: string,
  options: ApiOptions = {}
): Promise<T> {
  const { method = "GET", body, headers = {} } = options;

  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;
  const defaultHeaders: Record<string, string> = {
    ...(!(body instanceof FormData) && { "Content-Type": "application/json" }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method,
    headers: defaultHeaders,
    body:
      body instanceof FormData
        ? body
        : typeof body === "string"
        ? body
        : body
        ? JSON.stringify(body)
        : undefined,
  });

  const responseData = await response
    .json()
    .catch(() => ({ message: "An error occurred" }));

  if (!response.ok) {
    // Create an error object that includes both the error message and any additional data
    const errorMessage =
      responseData.error || responseData.message || "An unknown error occurred";
    const error = new Error(errorMessage) as Error & Record<string, any>;

    // Add any additional properties from the response to the error object
    if (responseData.existingEmails) {
      error.existingEmails = responseData.existingEmails;
    }

    // Handle 401 Unauthorized errors specifically
    if (response.status === 401) {
      error.isAuthError = true;
    }

    throw error;
  }

  return responseData;
}
